export default __webpack_public_path__ + "static/media/visa.72a03471.svg";